import React, { Fragment, useRef, useEffect, useState } from 'react';
import { translate } from '../Services/translation';
import QuickSearch from './QuickSearch';
import SubCategories from './SubCategories';
import FavoriteProductsIcon from './FavoriteProductsIcon';

const NavigationItem = ({ links = [], level = 1, contentLink = null, contentLinkClass = null, searchType, favoritePageUrl, hideSearch }) => {
    let breakPointWidth = 1180;
    let menuRef = React.createRef();
    function toggleMenu() {
        menuRef.current.classList.toggle('ti-megamenu--show');
        document.body.classList.toggle("locked");
        var root = document.documentElement;
        root.classList.toggle("locked");
    }


    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (!event.target.classList.contains("ti-svg-icon") && !event.target.classList.contains("quick-search__input") && !event.target.classList.contains("product__name") &&
                !event.target.classList.contains("product__image") && !event.target.classList.contains("product__image--missing")
                && !event.target.classList.contains("quick-search-result__result-name")
                && !event.target.classList.contains("quick-search-result__show-all-header")
                && window.innerWidth < breakPointWidth) {
                var container = document.getElementById("quick-search-container");

                if (container.classList.contains("quick-search--show")) {
                    container.classList.remove("quick-search--show");
                    document.body.classList.toggle("lock-scroll-search");
                    document.body.classList.toggle("quick-search__grey-background");
                }
            }
        }
        if (window.innerWidth < breakPointWidth) {
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [menuRef]);


    function searchFocus() {
        var container = document.getElementById("quick-search-container");

        container.classList.toggle("quick-search--show");
        document.body.classList.toggle("lock-scroll-search");
        document.body.classList.toggle("quick-search__grey-background");
        var input = document.getElementById("quick-search-input");
        if (input) {
            input.focus();
        }
    }
    const [activeId, setToggleState] = useState(null);
    function isTouchDevice() {
        return (('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0));
    }

    function setMenuState(menuItem) {
        if (!menuItem || menuItem.id === activeId) {
            setToggleState(null);
        } else {
            setToggleState(menuItem.id);
        }
    }

    function toggleMenuClick(menuItem) {
        const isTouch = isTouchDevice();
        if (!isTouch) {
            return;
        }
        setMenuState(menuItem);
    }
    function toggleMenuHover(menuItem) {
        const isTouch = isTouchDevice();
        if (isTouch) {
            return;
        }
        setMenuState(menuItem);
    }
    const additionClass = contentLink && contentLink.attributes ? contentLink.attributes.cssValue : null;
    const imageUrl = contentLink && contentLink.sortimentImageUrl ? contentLink.sortimentImageUrl : null;
    const imagePreTitle = contentLink && contentLink.sortimentImagePreTitle ? contentLink.sortimentImagePreTitle : null;
    const imageTextColor = contentLink && contentLink.sortimentImageTextColor ? contentLink.sortimentImageTextColor : null;
    const imageTitle = contentLink && contentLink.sortimentImageTitle ? contentLink.sortimentImageTitle : null;
    const imageLink = contentLink && contentLink.sortimentLink ? contentLink.sortimentLink : null;
    const imageAlt = contentLink && contentLink.sortimentImageAlt ? contentLink.sortimentImageAlt : null;
    const hasNameOrChildren = link => link.name || (link.links || []).length > 0;
    const submenuClosed = false;

    return (
        <Fragment>
            {!contentLink ? (
                <div>
                    <div className="ti-megamenu__icon-container">
                        {!hideSearch && <a tabIndex={6} className="ti-menu-icon ti-menu-icon--menu " onClick={() => searchFocus()}>
                            <svg className="ti-svg-icon">
                                <use href="/ui/images/tibergs-svg/sprite/sprite.svg#search"></use>
                            </svg>
                        </a>}
                        <a className="ti-menu-icon ti-menu-icon--menu" onClick={() => toggleMenu()}>
                            <svg>
                                <use href="/ui/images/tibergs-svg/sprite/sprite.svg#menu"></use>
                            </svg>
                        </a>
                        <div className="favorite-products favorite-products__mobile">
                            <FavoriteProductsIcon favoritePageUrl={favoritePageUrl} />
                        </div>
                    </div>
                    {window.innerWidth < breakPointWidth && !hideSearch && <div className="quick-search__container">
                        <QuickSearch />
                    </div>}
                </div>

            ) : (
                <Fragment>

                    {contentLink.url ? (
                        <a className={`${contentLinkClass || ''} ${additionClass || ''}`}
                            href={contentLink.url || '#'}
                            dangerouslySetInnerHTML={GetLink(level, contentLink)}>
                        </a>
                    ) : (
                        <span className={`ti-menuitem__has-sub ${contentLinkClass || ''} ${additionClass || ''}`}
                            dangerouslySetInnerHTML={GetLink(level, contentLink)}></span>
                    )}
                </Fragment>
            )}

            {level == 1 && links.length > 0 &&
                <Fragment>

                    <div className="ti-megamenu" ref={menuRef}>
                        <div className="ti-megamenu__content">
                            <div className="ti-megamenu__close">
                                <a onClick={toggleMenu}>
                                    <svg>
                                        <use href="/ui/images/tibergs-svg/sprite/sprite.svg#close"></use>
                                    </svg>
                                </a>
                            </div>                            
                            <ul className="ti-menu" test={links.length}>
                                {links.length > 0 && links.map((link, i) => hasNameOrChildren(link) &&
                                    <li tabIndex={1} className={`${activeId === link.id ? 'open' : ''} ${link.links.length > 0 ? 'ti-menuitem ti-menuitem--assortment' : 'ti-menuitem'}`}
                                        onClick={() => toggleMenuClick(link)}
                                        onMouseLeave={() => toggleMenuHover(null)}
                                        onMouseEnter={() => toggleMenuHover(link)}
                                        key={!link.name ? `${new Date().getTime()}-${i}` : `${link.name}-${i}`}
                                    >
                                        <NavigationItem links={link.links} level={2} contentLink={link} />
                                    </li>
                                )}
                            </ul>
                            {window.innerWidth >= breakPointWidth && !hideSearch && <div className="ti-megamenu__search">
                                <QuickSearch />
                            </div>}
                            <div className="ti-megamenu__footer">
                                <a href={'mailto:' + translate('menu.mailcontact')}>{translate('menu.mailcontact')}</a><br />
                                <a href={'tel:' + translate('menu.phonecontact')}>{translate('menu.phonecontact')}</a>
                            </div>
                        </div>
                        <div className="overlay-close--sticky" onClick={toggleMenu}></div>
                    </div>
                </Fragment>
            }

            {level == 2 && links.length > 0 &&
                <div className="ti-submenu">
                    <div className="ti-submenu__inner">
                        <div className="ti-submenu__content">
                            <div className="ti-submenu__links">
                                {links.length > 0 && links.map((link, i) => hasNameOrChildren(link) &&
                                    <div className="ti-submenu__section" key={i}>
                                        <NavigationItem links={link.links} level={3} contentLink={link} contentLinkClass={"ti-submenu__header"} />
                                    </div>
                                )}
                            </div>
                            {imageUrl != null && imageUrl != "" ?
                                <div className="ti-submenu__blurb">
                                    <a href={imageLink} className="ti-blurb">                                        
                                        <img src={imageUrl} alt={imageAlt}/>
                                        <div className="ti-blurb__info">
                                            <span className="ti-blurb__intro" style={imageTextColor ? { color: imageTextColor } : {}}>{imagePreTitle}</span>
                                            <h3 className="ti-blurb__header" style={imageTextColor ? { color: imageTextColor } : {}}>
                                                {imageTitle}
                                            </h3>
                                        </div>
                                    </a>
                                </div> : null}
                        </div>
                    </div>
                </div>
            }

            {level == 3 && links.length > 0 &&
                <ul className="ti-submenu__list">
                    {links.length > 0 && links.map((link, i) => hasNameOrChildren(link) &&
                        <li key={!link.name ? `${new Date().getTime()}-${i}` : `${link.name}-${i}`} className="ti-submenu__list-item">
                            <div className="ti-submenu__desktop-menu">
                                <NavigationItem links={link.links} level={4} contentLink={link} />
                            </div>
                            <div className="ti-submenu__mobile-menu">
                                <SubCategories link={link} callback={handleChildClick} submenuClosed={submenuClosed} />
                            </div>
                        </li>
                    )}
                </ul>
            }
        </Fragment>
    )
}

const handleChildClick = () => {
    document.getElementsByClassName("ti-megamenu")[0].classList.toggle("locked");
}

const GetLink = (level, contentLink) => {
    var stringLink = "";
    if (contentLink.attributes && contentLink.attributes.imageUrl) {
        stringLink += `<div class="ti-submenu__image" style="background-image: url('${contentLink.attributes.imageUrl}')"></div>`;
    }
    stringLink += contentLink.name;
    if (level === 2 || level === 4) {
        stringLink += '<svg tabindex="0" class="svg-arrow"><use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use></svg>';
    }
    return { __html: stringLink };
};

export default NavigationItem;
